module.exports = __webpack_public_path__ + "img/eldorBrLogo.64ec2a53.png";